import React from "react";

const TitleH2 = ({title}) => {
  return <>
    <h2 className="heading-xlarge text-align-center text-color-white">{title}</h2>
  </>
}

export default TitleH2;